const { render } = wp.element;
import App from './App.js';

render(<App />, document.getElementById('gei_catalogue_form'));
